module.exports = __webpack_public_path__ + "static/media/create_reservation_select_start_date.bbff076e.jpg";